/**
 * React Flow nodeTypes registry. Maps `node.type` → React component.
 * Add a new flow node here = new type renders on the canvas.
 */

import type { NodeTypes } from "@xyflow/react";
import { ArtifactFlowNode } from "./ArtifactFlowNode";
import { DataSourceFlowNode } from "./DataSourceFlowNode";
import { DataModelFlowNode } from "./DataModelFlowNode";
import { DataStoryFlowNode } from "./DataStoryFlowNode";
import { MetricFlowNode } from "./MetricFlowNode";
import { OntologyFlowNode } from "./OntologyFlowNode";
import { ReportFlowNode } from "./ReportFlowNode";
import { SchemaFlowNode } from "./SchemaFlowNode";
import { TableFlowNode } from "./TableFlowNode";

export const kgNodeTypes: NodeTypes = {
  dataSource: DataSourceFlowNode,
  schema:     SchemaFlowNode,
  table:      TableFlowNode,
  dataModel:  DataModelFlowNode,
  ontology:   OntologyFlowNode,
  metric:     MetricFlowNode,
  report:     ReportFlowNode,
  dataStory:  DataStoryFlowNode,
  artifact:   ArtifactFlowNode,
} as NodeTypes;

export { ArtifactFlowNode }  from "./ArtifactFlowNode";
export { DataSourceFlowNode } from "./DataSourceFlowNode";
export { SchemaFlowNode }     from "./SchemaFlowNode";
export { TableFlowNode }      from "./TableFlowNode";
export { DataModelFlowNode }  from "./DataModelFlowNode";
export { OntologyFlowNode }   from "./OntologyFlowNode";
export { MetricFlowNode }     from "./MetricFlowNode";
export { ReportFlowNode }     from "./ReportFlowNode";
export { DataStoryFlowNode }  from "./DataStoryFlowNode";
